import React from 'react';
import * as cls from './how-it-works.module.css';
import { Typography } from '../../../ui/components/typography';
import { Section } from '../../../ui/components/section';
import { IMG_PATH } from '../../../constants';

const items = [
  {
    title: 'EV Car',
    imgChart: `${IMG_PATH}/amazon-shop/how-it-works-1.svg`,
    imgIcon: `${IMG_PATH}/amazon-shop/how-it-works-1-ev-car.png`,
  },
  {
    title: 'Washing Machine',
    imgChart: `${IMG_PATH}/amazon-shop/how-it-works-2.svg`,
    imgIcon: `${IMG_PATH}/amazon-shop/how-it-works-2-washing-machine.png`,
  },
  {
    title: 'Fridge',
    imgChart: `${IMG_PATH}/amazon-shop/how-it-works-3.svg`,
    imgIcon: `${IMG_PATH}/amazon-shop/how-it-works-3-fridge.png`,
  },
  {
    title: 'Cooker',
    imgChart: `${IMG_PATH}/amazon-shop/how-it-works-4.svg`,
    imgIcon: `${IMG_PATH}/amazon-shop/how-it-works-4-cooker.png`,
  },
];

export const HowItWorks = () => {
  return (
    <Section>
      <Typography as="h1" tag="h2">
        How It Works
      </Typography>

      <div className={cls.items}>
        {items.map((item, index) => (
          <img
            alt="Voltaware sensor measures whole-home usage"
            className={cls.item__img__chart}
            key={index}
            src={item.imgChart}
          />
        ))}
        {items.map((item, index) => (
          <div className={cls.item} key={index}>
            <Typography>{item.title}</Typography>
            <img alt="" src={item.imgIcon} />
          </div>
        ))}
      </div>

      <div className={cls.texts}>
        <Typography>
          Each home appliance has a unique electronic fingerprint.
        </Typography>

        <Typography>
          Voltaware's AI algorithms detect the energy use of your main
          appliances in real-time. Allowing you to understand and optimise your
          energy use while reducing your environmental impact.
        </Typography>

        <Typography>
          Your sensor will start recording your appliance use in the Voltaware
          Home app moments after installation and activation.
        </Typography>
      </div>
    </Section>
  );
};
